module.exports = __webpack_public_path__ + "img/icon_004.70eb9ba.png";